'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'forward-fast';
var width = 512;
var height = 512;
var aliases = [9197,"fast-forward"];
var unicode = 'f050';
var svgPathData = 'M272 102.6L272 409.4 425.4 256 272 102.6zm6.6 368c-9.2 9.2-22.9 11.9-34.9 6.9S224 460.9 224 448l0-146.7-169.4 169.4c-9.2 9.2-22.9 11.9-34.9 6.9S0 460.9 0 448L0 64C0 51.1 7.8 39.4 19.8 34.4s25.7-2.2 34.9 6.9L224 210.7 224 64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9L464 226.7 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-170.7-185.4 185.4zM201.4 256L48 102.6 48 409.4 201.4 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faForwardFast = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;